import React from "react";
import { ColorValue, View } from "react-native";
import { ActivityIndicator, Modal } from "react-native-paper";

interface LoadingSpinnerOverlayProps {
  visible: boolean;
  overLayBackgroundColor?: ColorValue | undefined;
}

/**
 * A LoadingSpinnerOverlay component that renders a full screen overlay with an animating ActivityIndicator. The overlay's background color can be specified via the `overLayBackgroundColor` prop.
 *
 * @param {boolean} visible - Whether the overlay should be visible or not.
 * @param {ColorValue} [overLayBackgroundColor] - The background color of the overlay. Defaults to `rgba(0, 0, 0, 0.5)`.
 *
 * @example
 * <LoadingSpinnerOverlay visible={true} />
 */
const LoadingSpinnerOverlay: React.FC<LoadingSpinnerOverlayProps> = ({
  visible,
  overLayBackgroundColor,
}) => {
  return (
    <Modal visible={visible}>
      <View
        style={{
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: overLayBackgroundColor ?? "rgba(0, 0, 0, 0.5)",
        }}
      >
        <ActivityIndicator animating={true} size="large" color={"#39BEB7"} />
      </View>
    </Modal>
  );
};

export default LoadingSpinnerOverlay;
